/** Recurly requires a state/province only for these ISO 3166-1 alpha-2 codes. */
export const COUNTRIES_REQUIRING_BILLING_STATE = ['US', 'CA', 'IT', 'NL'] as const;

export type BillingAddressFormConfig = {
  showState: boolean;
  stateLabelKey: string;
};

export const shouldShowBillingStateField = (countryCode?: string | null): boolean => {
  if (!countryCode) {
    return false;
  }

  return COUNTRIES_REQUIRING_BILLING_STATE.includes(
    countryCode.toUpperCase() as typeof COUNTRIES_REQUIRING_BILLING_STATE[number]
  );
};

export const getBillingAddressFormConfig = (countryCode?: string | null): BillingAddressFormConfig => {
  const country = countryCode?.toUpperCase() ?? '';
  const showState = shouldShowBillingStateField(country);

  if (country === 'US') {
    return {
      showState,
      stateLabelKey: 'common:paywall.checkout.billingAddress.stateRegion',
    };
  }

  if (country === 'CA') {
    return {
      showState,
      stateLabelKey: 'common:paywall.checkout.billingAddress.province',
    };
  }

  return {
    showState,
    stateLabelKey: 'common:paywall.checkout.billingAddress.stateRegion',
  };
};
